<template>
    <div class="page__container">
        <BreadCrumbsTemplate/>
      <VacanciesTemplate />
    </div>
  </template>
  
  <script>
  import BreadCrumbsTemplate from '@/components/BreadCrumbsTemplate.vue';
import VacanciesTemplate from '@/components/VacanciesTemplate.vue';
  
  export default {
    components: {
    VacanciesTemplate,
    BreadCrumbsTemplate
}
  };
  </script>
  
  <style scoped>
  .vacancies-view {
    max-width: 800px;
    margin: auto;
  }
  </style>